import type { FaireProductEntity } from "../../entity_types/product";

export const p_ampzfn83uf: FaireProductEntity = {
  token: "p_ampzfn83uf",
  type: "product",
  name: "Itty-Bitty Bingo",
  brandToken: "b_bomzcs63",
  brandName: "Hachette Book Group",
  imageUrl: "https://cdn.faire.com/fastly/4dafa379135b981f0ec6340ee610d43e44dc79f52bab70ec8e4941937de2791a.jpeg",
  galleryImageUrls: [],
  priceDollars: 7.48,
  description: "Bring the fun of bingo anywhere with this travel-size version of the classic game that includes everything you need to play—complete with a portable 3 1/2 inch bingo wheel! This all-in-one set features a 3 1/2 inch mini bingo wheel cage with storage drawer, 75 number balls, call tray, 6 mini number cards, and 3 sheets of reusable sticker bingo markers. It also includes a 32-page mini book with instructions and variations of the game. The mini size is perfect for a desktop or taking on the go, making it a unique gift for bingo lovers of all ages.",
  tags: [],
  msrpDollars: 14.95,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-28T21:06:54.135Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
